import {
  BON_DE_COMMANDE_STATUS,
} from "modules/bonDeCommande/types/bonDeCommande.interface";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { Autocomplete, Option } from "components/fields/autoCompleteField";
import { CreateBonDeCommandePayload } from "modules/bonDeCommande/types/bonDeCommande.interface";

export interface SelectStatusProps {
  formValues: CreateBonDeCommandePayload;
  setFormValues: (values: CreateBonDeCommandePayload) => void;
}

export const statusLabels: Record<BON_DE_COMMANDE_STATUS, string> = {
  [BON_DE_COMMANDE_STATUS.DRAFT]: "📝 En cours",
  [BON_DE_COMMANDE_STATUS.VALIDATED]: "✅ Validé",
  [BON_DE_COMMANDE_STATUS.SENT]: "📨 Envoyé",
  [BON_DE_COMMANDE_STATUS.PAID]: "💰 Payé",
};

export const SelectStatus: FunctionComponent<SelectStatusProps> = ({
  formValues,
  setFormValues,
}) => {
  const options: Option[] = useMemo(
    () =>
      Object.values(BON_DE_COMMANDE_STATUS).map((status) => ({
        id: status,
        name: statusLabels[status],
      })),
    []
  );
  
  // Initialize searchValue based on the current status
  const initialValue = formValues.status ? statusLabels[formValues.status] : "";
  const [searchValue, setSearchValue] = useState<string>(initialValue);

  const handleOptionChange = (optionValue: Option) => {
    setFormValues({
      ...formValues,
      status: optionValue.id as BON_DE_COMMANDE_STATUS,
    });
  };

  // Update searchValue whenever formValues.status changes (including API fetch)
  useEffect(() => {
    if (formValues.status) {
      const status = options.find((option) => option.id === formValues.status);
      if (status) {
        setSearchValue(status.name);
      }
    }
  }, [formValues.status, options]);

  if (options.length < 1) return null;

  return (
    <Autocomplete
      options={options}
      onSelect={handleOptionChange}
      value={formValues.status ? [formValues.status] : []}
      label="Sélectionner un statut"
      searchValue={searchValue}
      setSearchValue={setSearchValue}
    />
  );
};
